import { Component } from '@angular/core';
import { NavController, NavParams, LoadingController, ModalController, ToastController } from 'ionic-angular';
import { Globals } from "../../../globals";
import { ReservationsServices } from '../services';
import { AngularFirestore } from 'angularfire2/firestore';
import * as firebase from 'firebase';
import { ModalExtraInput } from '../../components/modal-extra-input/modal-extra-input';
import { TranslateService } from '@ngx-translate/core';
import { ConfigurationDomainsPage } from '../../configuration/configuration-domains/configuration-domains';


@Component({
    selector: 'page-reservation-config',
    templateUrl: 'reservation-config.html',
})
export class ReservationConfig {

    firestore: any;

    arr_extra_inputs: any = [];
    order: number = 0;
    policy: string = '';
    _policy: string = '';
    domini: string = '';
    reservation_text: string = '';

    constructor(public navCtrl: NavController,
        public navParams: NavParams,
        public loadingCtrl: LoadingController,
        public globals: Globals,
        public reservationsServices: ReservationsServices,
        public afs: AngularFirestore,
        private modalCtrl: ModalController,
        private toastCtrl: ToastController,
        public translate: TranslateService,
        private translateService: TranslateService
    ) {
        this.firestore = firebase.firestore();
        this.reservation_text = this.globals.restaurant.reservation_text_web;

    }

    //Crear la subcolection extraImputs
    createExtraInput() {
        //crear la subcolection extraInputs
        var extra_inputs = {
            title: '',
            type: 'text',
            options: '',
            order: this.order
        }

        this.order++;

        this.afs.collection('restaurants/' + this.globals.restaurant_uid + '/reservations/config/extra_inputs/').add(extra_inputs).then(ref => {
            extra_inputs['UID'] = ref.id;
            extra_inputs['array_options'] = [];
            this.arr_extra_inputs.push(extra_inputs);
        });
        this.editExtraInput(extra_inputs);
    }

    //abrir el ModalExtraInput para modificar los datos
    editExtraInput(reservation) {
        let modalExtraInput = this.modalCtrl.create(ModalExtraInput,
            {
                extra_input: reservation
            });
        modalExtraInput.onDidDismiss(async data => {
            if (data != undefined) {
                if (data.type == "update") {
                    var index = this.arr_extra_inputs.findIndex(item => item.UID == data.UID);
                    var array_options = [];

                    //separamos las opciones
                    var options = data.extra_input.options.split(';');
                    options.forEach(element => {
                        if (element.length > 0) {
                            array_options.push(element);
                        }
                    });
                    this.arr_extra_inputs[index].array_options = array_options;
                    this.arr_extra_inputs.sort((a, b) => (a.order < b.order ? -1 : 1));
                } else if (data.type == "delete") {
                    this.arr_extra_inputs = this.arr_extra_inputs.filter(item => item.UID !== data.UID);
                }

            }
        });
        modalExtraInput.present();
    }





    //recuperamos los datos de la subcolection extraInputs
    async getExtraInputs() {
        this.arr_extra_inputs = [];

        this.firestore.collection('restaurants/' + this.globals.restaurant_uid + '/reservations/config/extra_inputs').orderBy('order').get()
            .then(snapshot => {
                snapshot.forEach(doc => {
                    var _doc = doc.data();
                    _doc.UID = doc.id;
                    _doc.array_options = [];

                    //separamos las opciones
                    var options = _doc.options.split(';');
                    options.forEach(element => {
                        if (element.length > 0) {
                            _doc.array_options.push(element);
                        }
                    });
                    this.arr_extra_inputs.push(_doc)
                });
                if (this.arr_extra_inputs.length > 0) {
                    this.order = parseInt(this.arr_extra_inputs[this.arr_extra_inputs.length - 1]) + 1;
                }
            });

        //
        var config = await this.firestore.collection('restaurants/' + this.globals.restaurant_uid + '/reservations').doc('config').get();
        if (config.data().privacy_policy) {
            this._policy = config.data().privacy_policy;
        } else {
            this._policy = this.globals.restaurant.privacy_policy;
            this.firestore.collection('restaurants/' + this.globals.restaurant_uid + '/reservations').doc('config').update({
                'privacy_policy': this._policy,
            });
        }
    }

    async ionViewWillEnter() {
        await this.getExtraInputs();
        this.getDomini();

    }

    public getInitObservations(editor: any) {
        if (editor.html) {
            this.policy = editor.html;
        }
    }

    savePolicy() {
        this.afs.collection('restaurants/' + this.globals.restaurant_uid + '/reservations').doc('config').update({
            privacy_policy: this.policy
        }).then(ref => {
            let toast = this.toastCtrl.create({
                message: this.translateService.instant('general-guardado-correctamente'),
                duration: 3000,
                position: 'bottom'
            });
            toast.present();
        });
        //
        this.afs.collection('restaurants').doc(this.globals.restaurant_uid).update({
            privacy_policy: this.policy
        }).then(ref => {
            this.globals.restaurant.privacy_policy = this.policy;
        });
    }

    async getDomini() {
        const publicKeyRef = this.firestore.collection('public_key');
        //Recuperem el domini del restaurant
        await publicKeyRef.where('UID_RESTAURANT', '==', this.globals.restaurant_uid)
            .get()
            .then(snapshot => {
                snapshot.forEach(doc => {
                    let data = doc.data();
                    //Si tiene el addon pro cogemos el dominio
                    if (this.globals.checkLimitsByLicense('sites', 'web_config')) {
                        if (data.domini == undefined) {
                            this.domini = doc.id;
                        } else {
                            this.domini = data.domini;
                        }
                    } else {
                        this.domini = doc.id;
                    }
                });
            });
    }

    openDomainConfig() {
        this.navCtrl.push(ConfigurationDomainsPage);
    }

    public getReservationText(editor: any) {
        if (editor.html) {
            this.reservation_text = editor.html;
        } else {
            this.reservation_text = '';
        }
    }

    saveReservationText() {
        this.afs.collection('restaurants').doc(this.globals.restaurant_uid).update({
            reservation_text_web: this.reservation_text
        }).then(ref => {
            let toast = this.toastCtrl.create({
                message: this.translateService.instant('general-guardado-correctamente'),
                duration: 3000,
                position: 'bottom'
            });
            toast.present();
            this.globals.restaurant.reservation_text_web = this.reservation_text;
        });
    }

}



// WEBPACK FOOTER //
// ./src/pages/reservation/reservation-config/reservation-config.ts